module.exports = __webpack_public_path__ + "img/correct.19d9a356.svg";